import * as React from 'react';
import * as $ from 'jquery';
import { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';

export interface PCBoundedProps {
    container : string;
    padding? : number;
    className? : string;
    children? : any;
}

export class PCBounded extends SuperCriticalComponent<PCBoundedProps> {
    ref : (e : HTMLDivElement | null) => void;

    constructor(props : PCBoundedProps) {
        super(props);
        this.ref = SuperCriticalReference(this, BoundElement);
    }

    srender(props : PCBoundedProps) : React.ReactElement<any> {
        return (
            <div className={'pc-bounded ' + (props.className ? props.className : '')} ref={this.ref}>
                {props.children}
            </div>
        );
    }
}


function BoundElement(props : PCBoundedProps, el : HTMLDivElement) {
    let $el = $(el),
        $container = $(props.container),
        padding = props.padding || 0,
        $elOffset = $el.offset() || {
            left: 0,
            top: 0
        },
        $elWidth = $el.width(),
        $elHeight = $el.height(),
        $containerOffset = $container.offset() || {
            left: 0,
            top: 0
        },
        $containerWidth = $container.width(),
        $containerHeight = $container.height();

    $containerOffset.left = $containerOffset.left + $container.scrollLeft();
    $containerOffset.top = $containerOffset.top + $container.scrollTop();

    let newLeft : number | undefined, newTop : number | undefined;

    if ($elOffset.left + $elWidth + padding > $containerOffset.left + $containerWidth) {
        newLeft = Math.max($containerOffset.left + padding, $containerOffset.left + $containerWidth - $elWidth - padding);
    }

    if ($elOffset.left < $containerOffset.left + padding) {
        newLeft = $containerOffset.left + padding;
    }

    if ($elOffset.top + $elHeight + padding > $containerOffset.top + $containerHeight) {
        newTop = Math.max($containerOffset.top + padding, $containerOffset.top + $containerHeight - $elHeight - padding);
    }

    if ($elOffset.top < $containerOffset.top + padding) {
        newTop = $containerOffset.top + padding;
    }

    if (newLeft !== undefined || newTop !== undefined) {
        $el.offset({
            left: newLeft !== undefined ? newLeft : $elOffset.left,
            top: newTop !== undefined ? newTop : $elOffset.top
        });
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/pcbounded/view.tsx